export default function (props: any) {
    const { fillPath = '#FFFFFF', ...reset } = props;
    return (
        <svg height={props?.size || '40'} viewBox="0 0 40 40" width={props?.size || '40'} xmlns="http://www.w3.org/2000/svg" {...reset}>
            <g fill={props?.fill || 'none'} fillRule="evenodd">
                <circle cx="20" cy="20" r="20" />
                <path
                    d="m12.4960649 23.8817279c-.2684854-.2684855-.2908592-.6898851-.0671213-.9838562l.0671213-.076804 7.0710678-7.0710678c.2684855-.2684854.6898851-.2908592.9838563-.0671213l.0768039.0671213 7.0710678 7.0710678c.2928932.2928932.2928932.767767 0 1.0606602-.2684854.2684854-.6898851.2908592-.9838562.0671214l-.076804-.0671214-6.5410622-6.5403174-6.5404132 6.5403174c-.2684855.2684854-.6898851.2908592-.9838562.0671214z"
                    fill={fillPath}
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
}
